import React, {JSX, useEffect} from 'react';

import {ErrorBoundary, setTag, setUser} from '@sentry/react';
import {getUser} from 'src/modules/admin/services';
import {useAppSelector} from 'src/store';

import Loading from '@pb/kit-component-loading';
import {LocalStorage} from '@pb/kit-util-client-storage';

type Props = {
    children: JSX.Element,
};

const APP_NAME = 'ud-event-design-tool-ui';

export const SentryController = ({children}: Props) => {
    const userId = useAppSelector(getUser)?.id ?? LocalStorage.get('user')?.id;

    useEffect(() => {
        setTag('applicationName', APP_NAME);
    }, []);

    useEffect(() => {
        setUser({id: userId});
    }, [userId]);

    return (
        <ErrorBoundary fallback={<Loading fast={true}/>}>
            {children}
        </ErrorBoundary>
    );
};
